import { useNavigate } from "react-router-dom";
import { PageTitle } from "@/components/PageHeader";
import { useDash } from "./ctx";
import { Sparkles, ArrowLeft } from "lucide-react";
import LiveDemoPanel from "./LiveDemoPanel";
import { V } from "@/lib/vocab";

export default function Simulator() {
  const { tenantId, tenant } = useDash();
  const navigate = useNavigate();
  // Live Demo is reached from Conversations / Settings and usually has no menu entry of its own,
  // so it needs its own way back (owner: "the Live Demo link traps you").
  const goBack = () => (window.history.length > 1 ? navigate(-1) : navigate("/dashboard/conversations"));
  return (
    <div className="space-y-6">
      <div>
        <button type="button" data-testid="live-demo-back" onClick={goBack}
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-ink/60 hover:text-ink transition-colors mb-3">
          <ArrowLeft className="h-4 w-4" /> Back
        </button>
        <div className="inline-flex items-center gap-1.5 rounded-full bg-ink text-white text-[11px] font-semibold px-3 py-1 mb-3 ml-3">
          <Sparkles className="h-3 w-3" /> Test drive
        </div>
        <PageTitle title="Live Demo" about={<>Text your concierge exactly like {V.a("person")} would — answering live from <span className="font-semibold text-ink">{tenant?.persona_name || tenant?.name || `this ${V.lc("org")}`}</span>'s own documents & roster. Tap a scenario to see a real reply, or type your own.</>} />
      </div>
      <LiveDemoPanel tenantId={tenantId} tenant={tenant} />
    </div>
  );
}
